// extracted by mini-css-extract-plugin
export default {"form":"LoginForm_form__WZhUZ","actionsWrapper":"LoginForm_actionsWrapper__wYFcP"};